import { FC } from 'react';
import Icon from '../icon';
import useCopyWithToast from '@/hooks/use-copy-with-toast.hook';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Tooltip from '../tooltip';

interface Props {
  value: string;
  className?: string;
  size?: 'medium' | 'small' | 'x-small';
  tooltip?: string;
  type?: 'copy' | 'resource-id';
}

const useStyles = createUseStyles({
  icon: {
    opacity: 0.7,
    '&:hover': {
      opacity: 1,
    },
    alignItems: 'center',
  },
});

const CopyClipButton: FC<Props> = ({
  value,
  className,
  size = 'medium',
  tooltip,
  type = 'copy',
}) => {
  const copyWithToast = useCopyWithToast();
  const handleCopy = () => {
    copyWithToast(value);
  };
  const styles = useStyles();
  const compClass = classNames(styles.icon, className);
  const hasTooltip = !!tooltip;
  const iconName = type === 'copy' ? 'copy' : 'copy-id';

  const IconEl = (
    <Icon name={iconName} size={size} onClick={handleCopy} className={compClass} color="active" />
  );

  if (!hasTooltip) {
    return IconEl;
  }

  return (
    <Tooltip title={tooltip} placement="bottom">
      {IconEl}
    </Tooltip>
  );
};

export default CopyClipButton;
